import React from 'react';
import { Wrapper } from '../Table/styled';
import SharedTable from 'shared/ui/Table';
import runStatusLogSchema from './schema';
import { useDispatch, useSelector } from 'react-redux';
import { multipleAgentExecutionSetSelected, setOrderByAgentsExecutions } from 'store/Agents/actions';
import { selectAgentExecutions, selectAgentExecutionSelected, selectAgentExecutionType, selectIsFetching } from 'store/Agents/selectors';
import { AGENTS_EXECUTION_ENTITY, CLOUD_AGENTS_EXECUTION_ENTITY } from 'store/Agents/reducer';
import { selectIsFiltering } from 'store/Filters/selectors';
import { get } from 'lodash';
import selectModal from 'store/modals/selectors';
import { MODAL_AGENT_EXECUTOR_DETAIL } from 'store/modals/modals';
import NoSearchResults from 'Common/Components/NoSearchResults';

const RunStatusLog = ({ agents }) => {
  const dispatch = useDispatch();
  const show = useSelector((state) => selectModal(state, MODAL_AGENT_EXECUTOR_DETAIL));
  const agentsExecutions = useSelector(selectAgentExecutions);
  const agentsExecutionsSelected = useSelector(selectAgentExecutionSelected);
  const agentType = useSelector(selectAgentExecutionType);
  const isFetching = useSelector(selectIsFetching);
  const executionEntity = agentType === 'agent_executions' ? AGENTS_EXECUTION_ENTITY : CLOUD_AGENTS_EXECUTION_ENTITY;
  const isFiltering = useSelector((state) => selectIsFiltering(executionEntity, state));

  const fetchData = (sorted) => {
    if (!isFetching) dispatch(setOrderByAgentsExecutions(sorted, agentType));
  };

  const isExecutionSelected = (rowInfo) => {
    const rowId = get(rowInfo, 'original.id', '');
    return agentsExecutionsSelected.some((e) => e.id === rowId);
  };

  const getTrProps = (rowInfo) => {
    const isSelected = isExecutionSelected(rowInfo);
    if (rowInfo && rowInfo.row) {
      return {
        onContextMenu: (e) => {
          e.preventDefault();
          if (!isSelected) {
            dispatch(multipleAgentExecutionSetSelected)(rowInfo.original);
          }
        }
      };
    }
    return {};
  };

  let noDataText = '';
  if (!isFetching) noDataText = isFiltering ? <NoSearchResults /> : 'No executions found';

  return (
      <Wrapper>
        <SharedTable
          schema={ runStatusLogSchema }
          context={ { show, agentType, isFetching } }
          data={ agentsExecutions }
          isLoading={ isFetching }
          onFetch={ fetchData }
          noDataText={ noDataText }
          getRowProps={ (rowInfo) => getTrProps(rowInfo) }
          isRowSelected={ isExecutionSelected }
        />
      </Wrapper>
  );
};

export default RunStatusLog;
